<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-12 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2"><h2 class="text-info">Telkom Credit</h2></div>
                          <div class="card-body text-center">
                            <div class="mb-3 row justify-content-center">
                              <div class="col-sm-6 float-right">
                              <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">
                              </div>
                            </div>
                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Account</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Amount</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Credit</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                        <th class=" text-uppercase  text-xxs font-weight-bolder ">Method</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                        {{data.account}}
                      </td>
                      <td >
                      Ksh.{{formatPrice(data.amount)}}
                      </td>
                      <td >
                       Ksh.{{formatPrice(data.credit)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>
                      <td  v-if="data.disbursed==='N'">
                       <i class="text-danger">PENDING</i>
                      </td>
                      <td  v-else>
                       <i class="text-success">DISBURSED</i>
                      </td>
                      <td >
                        {{data.TransactionType}}
                      </td>
                      <td  v-if="data.disbursed==='N'">
                        <a v-on:click="getAuthOTP(data.id)" class="ml-5" href="#">Disburse <i class="mdi mdi-reply-all"></i></a>
                        </td>

                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="logs"  @changePage="onChangePage" ></jw-pagination>
                    </div>
                </div>

                          </div>
                        </div>




                        </div>
                        </div>

  <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Update Airtime transaction</h6>
         <p class="text-center">A four digit verification code  has been sent to your phone.Please enter the code to complete transaction</p>

         <p class="text-center"><b>NOTE:</b>This transaction will award <b>{{message.account}}</b> Airtime of Ksh.<b>{{formatPrice(message.credit)}}</b></p>
         <p class="text-center">Please click Complete to authorise</p>

         <div class="form-group mt-3">
                    <label class="form-label">OTP</label>
                    <input type="text" v-model="message.code" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Account</label>
                    <input type="text" v-model="message.account" class="form-control" required>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="buyAirtelCredit()">Compelete</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            logs:[],
             logs2:[],
            message:{},
            pageOfItems:[],

            }
        },
        created(){
              this.getAirtelLogs();
        },
        methods: {
           onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
          buyAirtelCredit(){
             $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/buyAirtelCredit/${this.message.id}`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                    this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                  this.getAirtelLogs();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          getAuthOTP(id){
             this.$loading(true)
               let uri =`/api/auth/getAuthOTP/${id}`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                    this.message=response.data.logs
                   $('#edit').modal('show');
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },

            getAirtelLogs(){

                let uri =`/api/auth/getTelkomLogs`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {

                 this.logs=response.data;
                 this.logs2=response.data;
                }).catch(error => {

                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

           filter(){
            let filterval=this.message.filterval;
            if(filterval==='' || filterval===null){
                this.logs=this.logs2;
            }else{
                let ads =  this.logs2.filter(function(product) {
                    return product.mpesa_ref.toLowerCase().includes(filterval.toLowerCase()) || product.account.toLowerCase().includes(filterval.toLowerCase()) || product.phone.toLowerCase().includes(filterval.toLowerCase())
                });
                this.logs=ads;
            }
        },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm');
            }

        },
    }

</script>
